<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto billing-errors-dialog-root" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column px-3 pt-4 pb-3 px-md-4 pt-md-4 gap-3 w-100 position-relative billing-errors-dialog-body">

    <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
      {{ "su-management.billing-errors-dialog-title" | translate }}
    </h4>

    <!-- כותרת: מייל וטלפון (תמיד); הזמנה וסניף — מצב הזמנה בלבד -->
    <div *ngIf="showUserContactHeader" class="billing-errors-panel w-100 rounded-3 p-3" [class.billing-errors-panel--dark]="isDarkMode">
      <div class="d-flex flex-column gap-2 zx-text-small" [class.text-white]="isDarkMode">
        <div class="d-flex flex-wrap align-items-center gap-2">
          <span class="billing-errors-kv-label">{{ "su-management.users.email-label" | translate }}:</span>
          <span class="fw-semibold" [class.zx-ltr]="!isRTL">{{ userEmail }}</span>
        </div>
        <div class="d-flex flex-wrap align-items-center gap-2">
          <span class="billing-errors-kv-label">{{ "my-profile.phone" | translate }}:</span>
          <span class="fw-semibold" [class.zx-ltr]="!isRTL">{{ userPhone }}</span>
        </div>
        <ng-container *ngIf="showOrderHeader">
        <div class="d-flex flex-wrap align-items-center gap-2">
          <span class="billing-errors-kv-label">{{ "su-management.printnode-dialog-order-label" | translate }}:</span>
          <span class="fw-semibold zx-ltr">{{ orderIdShort }}</span>
        </div>
        <div class="d-flex flex-wrap align-items-center gap-2 pt-1">
          <img *ngIf="order && !order.branchID?.is_express && !isPHOrder(order)"
            src="assets/images/plotter-icon.svg" alt="" class="zx-small-icon-size" />
          <img *ngIf="order && order.branchID?.is_express && !isPHOrder(order)"
            [src]="'assets/images/' + getIsPics(order.printerID) + '-icon.svg'" alt="" class="zx-small-icon-size" />
          <img *ngIf="order && !order.branchID?.is_express && !isPHOrder(order)"
            [src]="'assets/images/branches/' + order.branchID?.serial_name + '.png'" alt="" class="zx-small-icon-size" />
          <img *ngIf="order && order.branchID?.is_express && !isPHOrder(order)"
            [src]="'assets/images/branches/' + order.printerID?.serial_name + '.png'" alt="" class="zx-small-icon-size" />
          <img *ngIf="order && isPHOrder(order)" [src]="getPhSystemIconSrcForOrder(order)" alt=""
            class="zx-small-icon-size" />
          <img *ngIf="order && isPHOrder(order)"
            [src]="'assets/images/products/' + order.productID?.name + '.svg'" alt="" class="zx-small-icon-size" />
          <span *ngIf="getBranchNamingKey(order) as branchKey" class="fw-semibold">
            {{ branchKey | translate }}
          </span>
          <span *ngIf="isPHOrder(order) && order?.productID?.name" class="fw-semibold">
            {{ "choose-product.naming." + order.productID.name | translate }}
          </span>
        </div>
        </ng-container>
      </div>
    </div>

    <!-- רשימת עסקאות -->
    <div class="w-100" *ngIf="transactions.length">
      <div class="d-flex align-items-center gap-2 mb-2 px-1">
        <mat-icon class="billing-errors-section-ico" [class.text-white]="isDarkMode">receipt_long</mat-icon>
        <span class="fw-bold zx-text-small" [class.text-white]="isDarkMode">
          {{ "su-management.billing-errors-dialog-transactions-section" | translate }}
        </span>
      </div>
      <div class="d-flex flex-column gap-2">
        <div *ngFor="let tx of transactions; let i = index"
          class="billing-errors-tx-card rounded-3 p-3"
          [class.billing-errors-tx-card--dark]="isDarkMode">
          <div class="d-flex align-items-center gap-2 mb-2">
            <span class="billing-errors-tx-index fw-bold" [class.text-white]="isDarkMode">#{{ i + 1 }}</span>
          </div>
          <div class="d-flex flex-column gap-1 zx-text-small" [class.text-white]="isDarkMode">
            <div *ngIf="isUserMode" class="d-flex flex-wrap gap-2">
              <span class="billing-errors-kv-label">{{ "su-management.printnode-dialog-order-label" | translate }}:</span>
              <span class="fw-semibold zx-ltr">{{ formatOrderIdShort(tx.orderID) }}</span>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <span class="billing-errors-kv-label">{{ "su-management.billing-errors-dialog-response-text" | translate }}:</span>
              <span class="fw-semibold">{{ tx.responseText || "—" }}</span>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <span class="billing-errors-kv-label">{{ "su-management.billing-errors-dialog-response-code" | translate }}:</span>
              <span class="fw-semibold zx-ltr">{{ tx.responseCode || "—" }}</span>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <span class="billing-errors-kv-label">{{ "su-management.business-management.total" | translate }}:</span>
              <span class="fw-semibold zx-ltr">{{ formatSum(tx.sum) }}</span>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <span class="billing-errors-kv-label">{{ "ph-order-action.obligated-date" | translate }}:</span>
              <span class="fw-semibold zx-ltr">{{ formatCreated(tx.created) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="!transactions.length" class="text-center py-3" [class.text-white]="isDarkMode">
      {{ "su-management.billing-errors-dialog-empty" | translate }}
    </div>

    <div class="d-flex justify-content-center pt-2 w-100 billing-errors-footer">
      <button type="button" mat-raised-button color="primary" (click)="closeDialog()"
        class="rounded-pill px-4 fw-bold text-white billing-errors-close-btn">
        {{ "error-content-ok-btn" | translate }}
      </button>
    </div>
  </div>
</div>
